import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import logoImage from '../../assets/images/lws-logo-dark.svg';
import { userLoggedOut } from '../../features/auth/authSlice';
import { ReactComponent as LogoutIcon } from '../../assets/icons/logout.svg';
import { ReactComponent as UserIcon } from '../../assets/icons/user.svg';
export default function Navigation() {
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.auth) || {};
  const { email, name } = user || {};

  const logout = () => {
    dispatch(userLoggedOut());
    localStorage.clear();
  };
  return (
    <nav className="border-general sticky top-0 z-40 border-b bg-violet-700 transition-colors px-4">
      <div className="max-w-7xl mx-auto">
        <div className="flex justify-between h-16 items-center">
          <Link to="/">
            <img className="h-10" src={logoImage} alt="Learn with Sumit" />
          </Link>
          <ul className="flex items-center space-x-4">
            {email && (
              <li className="text-white flex items-center">
                <UserIcon className="h-8 w-8 fill-white mr-1 mt-[1px]" />
                <span>{name}</span>
              </li>
            )}
            <li
              className="text-white cursor-pointer flex items-center"
              onClick={logout}
            >
              <LogoutIcon className="h-8 w-8 fill-white mr-1 mt-[1px]" />
              <span>Logout</span>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
}
